import CommonRequests from "./CommonRequests";
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';

declare var cordova: any;

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.teknisa.portalgestor";
const HAS_SHOW_ALERT_UPDATE = 'HAS_SHOW_ALERT_UPDATE';
const PORTAL_GESTOR_VERSION = 'PORTAL_GESTOR_VERSION';

class CordovaController {
  /**
   * Método para verificar se há uma nova atualização disponível no App e, se houver, exibir um alerta.
   */
  static async checkForAppUpdates(): Promise<void> {
    try {

      return; // TODO: Remover após a implementação do endpoint de versão
      
      // Verifica se o app está rodando em um dispositivo móvel
      if(!this.isMobile()) return;

      // Evita exibir o alerta novamente na mesma sessão
      if (sessionStorage.getItem(HAS_SHOW_ALERT_UPDATE)) return;
  
      const currentVersion = await cordova.getAppVersion();

      const latestVersion = null; //await CommonRequests.getValorReferencia(PORTAL_GESTOR_VERSION, true);

      if(!latestVersion) return;

      if (currentVersion !== latestVersion) {

        // Marca que a mensagem foi exibida nesta sessão
        sessionStorage.setItem(HAS_SHOW_ALERT_UPDATE, 'true');

        await DialogUtils.show(
          'Nova versão disponível',
          "Uma nova versão do aplicativo está disponível! Deseja atualizar agora?",
          this.redirectToPlayStore,
        );

      }
    } catch (error) {
      console.error("Erro ao verificar atualizações:", error);
    }

  }

  /**
   * Método para redirecionar o usuário para a pagina do app na Play Store.
   */
  private static async redirectToPlayStore() {
    cordova.InAppBrowser.open(PLAY_STORE_URL, "_system");
  }


  /**
   * Verifica se o dispositivo é móvel.
   * @returns Verdadeiro se o dispositivo for móvel.
  */
  public static isMobile(): boolean {
    return window.cordova && window.cordova.platformId && window.cordova.platformId.toLowerCase() !== 'browser';
  }

  // Solicitar permissão de acesso à câmera no mobile
  public static checkCameraAccessMobile(): Promise<void> {
    return new Promise((resolve, reject) => {
        const permissions = cordova.plugins.permissions;
        permissions.checkPermission(permissions.CAMERA, (status) => {
            if (!status.hasPermission) {
                permissions.requestPermission(permissions.CAMERA, (status) => {
                    if (status.hasPermission) {
                        resolve();
                    } else {
                        reject('Permissão de câmera não concedida');
                    }
                }, (error) => {
                    console.error('Erro ao solicitar permissão de câmera:', error);
                    reject('Erro ao solicitar permissão de câmera');
                });
            } else {
                resolve();
            }
        }, (error) => {
            console.error('Erro ao verificar permissão de câmera:', error);
            reject('Erro ao verificar permissão de câmera');
        });
    });
  }

  public static checkStorageAccessMobile(): Promise<void> {
    return new Promise((resolve, reject) => {
      const permissions = cordova.plugins.permissions;
      const isAndroidSuperior10 = window.device && window.device.platform === 'Android' && parseInt(window.device.version) > 10;
  
      const storagePermissions = isAndroidSuperior10
        ? [permissions.READ_MEDIA_IMAGES, permissions.READ_MEDIA_VIDEO, permissions.WRITE_EXTERNAL_STORAGE]
        : [permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE];
  
      permissions.checkPermission(storagePermissions[0], (status) => {
        if (!status.hasPermission) {
          // Solicitar permissões
          permissions.requestPermissions(storagePermissions, (status) => {
            if (status.hasPermission) {
              resolve();
            } else {
              reject('Permissões de armazenamento não concedidas');
            }
          }, (error) => {
            console.error('Erro ao solicitar permissões de armazenamento:', error);
            reject('Erro ao solicitar permissões de armazenamento');
          });
        } else {
          resolve();
        }
      }, (error) => {
        console.error('Erro ao verificar permissões de armazenamento:', error);
        reject('Erro ao verificar permissões de armazenamento');
      });
    });
  }

  public static checkStorageAndCameraAccessMobile(): Promise<void> {
    return new Promise((resolve, reject) => {
      const permissions = cordova.plugins.permissions;
      const isAndroidSuperior10 = window.device && window.device.platform === 'Android' && parseInt(window.device.version) > 10;
  
      const storagePermissions = isAndroidSuperior10
        ? [permissions.READ_MEDIA_IMAGES, permissions.READ_MEDIA_VIDEO, permissions.CAMERA]
        : [permissions.READ_EXTERNAL_STORAGE, permissions.WRITE_EXTERNAL_STORAGE, permissions.CAMERA];
  
      permissions.checkPermission(storagePermissions[0], (status) => {
        if (!status.hasPermission) {
          // Solicitar permissões
          permissions.requestPermissions(storagePermissions, (status) => {
            if (status.hasPermission) {
              resolve();
            } else {
              reject('Permissões de armazenamento e câmera não concedidas');
            }
          }, (error) => {
            console.error('Erro ao solicitar permissões de armazenamento e câmera:', error);
            reject('Erro ao solicitar permissões de armazenamento e câmera');
          });
        } else {
          resolve();
        }
      }, (error) => {
        console.error('Erro ao verificar permissões de armazenamento e câmera:', error);
        reject('Erro ao verificar permissões de armazenamento e câmera');
      });
    });
  }
}

export default CordovaController
